// Copyright (c) 2017 Deere & Company

const flattenAccounts = (subAccounts, city, leadAccount) =>
    subAccounts.map(account => ({
        ...account,
        account: account.subAccount.account,
        city: city.city,
        leadAccount: leadAccount.leadAccount.account,
        leadAccountDisplayName: leadAccount.leadAccount.name
    }));

const traverseCities = (cities, leadAccount) =>
    cities.reduce((acc, city) =>
        acc.concat(flattenAccounts(city.accountSummary, city, leadAccount))
    , []);

export const buildSummary = leadAccounts => {

    const accounts = leadAccounts.reduce((acc, leadAccount) =>
        acc.concat(traverseCities(leadAccount.citySummary, leadAccount))
    , []);

    return {
        detail: {
            data: {},
            display: []
        },
        rowData: accounts
    };

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/services/summary.js